import { forwardRef } from "react";

import { Stack, Theme } from "@mui/material";

import { useRichTextToolbarState } from "./useRichTextToolbarState";

import { DashboardIconButton } from "@/dashboard-design-system/DashboardButton";
import { useRichTextContext } from "@/dashboard-design-system/RichTextInput/DashboardRichTextContext";
import { useRichTextToolbarCommand } from "@/dashboard-design-system/RichTextInput/useRichTextToolbarCommand";
import { Bold, Italic, OrderedList, Underline, UnorderedList } from "@/icons/outlined";

export const FloatingToolbar = forwardRef<HTMLDivElement>((_, ref) => {
  const { isToolbarPluginEnabled } = useRichTextContext();

  const { isBold, isItalic, isUnderline, isOrderedList, isUnorderedList } = useRichTextToolbarState();
  const { toggleBold, toggleItalic, toggleUnderline, toggleOrderedList, toggleUnorderedList } =
    useRichTextToolbarCommand();

  const styles = (theme: Theme) => ({
    backgroundColor: theme.palette.surface.neutral.white,
    border: `1px solid ${theme.palette.border.neutral.quiet}`,
    borderRadius: theme.radius(1),
  });

  return (
    <Stack ref={ref} direction="row" sx={styles}>
      <DashboardIconButton variant="text" vibe={isBold ? "brand" : "neutral"} onClick={toggleBold}>
        <Bold />
      </DashboardIconButton>
      <DashboardIconButton variant="text" vibe={isItalic ? "brand" : "neutral"} onClick={toggleItalic}>
        <Italic />
      </DashboardIconButton>
      <DashboardIconButton variant="text" vibe={isUnderline ? "brand" : "neutral"} onClick={toggleUnderline}>
        <Underline />
      </DashboardIconButton>
      {isToolbarPluginEnabled("lists") && [
        <DashboardIconButton
          key="unordered-list"
          variant="text"
          vibe={isUnorderedList ? "brand" : "neutral"}
          onClick={() => toggleUnorderedList(isUnorderedList)}
        >
          <UnorderedList />
        </DashboardIconButton>,
        <DashboardIconButton
          key="ordered-list"
          variant="text"
          vibe={isOrderedList ? "brand" : "neutral"}
          onClick={() => toggleOrderedList(isOrderedList)}
        >
          <OrderedList />
        </DashboardIconButton>,
      ]}
    </Stack>
  );
});

FloatingToolbar.displayName = "FloatingToolbar";
